import cn from 'classnames/bind';
import React from 'react';

import { useFinanceFilter } from '@/hooks/filters/finance-filter.hook';
import { BalloonTypes } from '@/types/filters/filters.types';

import styles from './balloon-options.module.scss';

const cx = cn.bind(styles);

export const BalloonOptions: React.FC<{
  savedValue?: any;
  onValueChange: (arg: number, name: string) => void;
  name?: string;
}> = ({ onValueChange, name, savedValue }) => {
  const { activeBalloonOption, setActiveBalloonOption } = useFinanceFilter();

  return (
    <div className={cx('paymentOptionsWrapper')}>
      <div
        className={cx('paymentOption', {
          paymentOptionSelected:
            activeBalloonOption === BalloonTypes.percentage,
        })}
        onClick={() => {
          setActiveBalloonOption(BalloonTypes.percentage);
          if (savedValue && name) {
            onValueChange(savedValue, name);
          }
        }}
      >
        %
      </div>
      <div
        className={cx('paymentOption', {
          paymentOptionSelected: activeBalloonOption === BalloonTypes.value,
        })}
        onClick={() => {
          setActiveBalloonOption(BalloonTypes.value);
          if (savedValue && name) {
            onValueChange(savedValue, name);
          }
        }}
      >
        R
      </div>
    </div>
  );
};
